import { friendsQueryOptions } from '@/hooks/contacts/use-friends';
import { allChatSessionQueryOptions } from '@/hooks/sessions/use-conversation-sessions';
import { catchFetcherError } from '@/utils/fetcher';
import { queryClient } from '@/utils/query-client';

export function contactLayoutLoader() {
  return {
    promises: Promise.allSettled([
      queryClient.ensureQueryData(allChatSessionQueryOptions),
      queryClient.ensureQueryData(friendsQueryOptions),
    ]).catch(catchFetcherError),
  };
}
